export const IS_INJECTABLE_KEY = Symbol('IS_INJECTABLE');
export const TOKEN_INJECTABLES = Symbol('TOKEN_INJECTABLES');
export const FACTORY_DEPS = Symbol('FACTORY_DEPS');
